import { CURRENT_LANG } from '@/helpers/lang'
import Cookies from 'js-cookie'

export const getCurrency = () => Cookies.get('userCurrency') || 'EUR'

export const formatCurrency = (value: number, currency: string) =>
  new Intl.NumberFormat(CURRENT_LANG, { currency: currency, style: 'currency' }).format(value)

export const formatAllSignatureCurrency = ({
  amount,
  currency
}: {
  amount?: number
  currency?: string
}): string => {
  const value = (amount ?? 0) / 100
  return formatCurrency(value, currency || 'BRL')
}
